import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.css";

export const PageFooter: React.FC<{ parentURL?: string }> = (props) => {
	const { parentURL } = props;

	const inner: ReactElement =
		parentURL === undefined ? (
			<>{props.children}</>
		) : (
			<Link className={styles.pageFooterLink} to={parentURL}>
				{props.children}
			</Link>
		);

	return <div className={styles.pageFooter}>{inner}</div>;
};
